import { render, staticRenderFns } from "./cardMenuRetailSimplifiedOnly.vue?vue&type=template&id=47521548&scoped=true"
import script from "./cardMenuRetailSimplifiedOnly.vue?vue&type=script&lang=js"
export * from "./cardMenuRetailSimplifiedOnly.vue?vue&type=script&lang=js"
import style0 from "./cardMenuRetailSimplifiedOnly.vue?vue&type=style&index=0&id=47521548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47521548",
  null
  
)

export default component.exports